import { render, staticRenderFns } from "./ActualizarModuloModal.vue?vue&type=template&id=1cdbb0e4"
import script from "./ActualizarModuloModal.vue?vue&type=script&lang=js"
export * from "./ActualizarModuloModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports